var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M1235,619h-21v-2h5v-3a1,1,0,0,1,1-1h11a1,1,0,0,1,1,1v3h5v2h-2Zm-5-4h-9v2h9v-2Zm-1,17h-2V621h2v11Zm-5,0h-2V621h2v11Zm-5,3h13V621h2v15a1,1,0,0,1-1,1h-15a1,1,0,0,1-1-1V621h2v14Z","transform":"translate(-1214 -613)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }